import React from 'react';
import { useSelector } from 'react-redux';

const TopHeader = () => {
  const topHeaderData = useSelector((state) => state.topHeader);
  const { delimiter, items } = topHeaderData;

  const mapItem = (item, index) => {
    const { iconUrl, linkUrl, text, url } = item;

    return (
      <div className="topheader-item" key={index}>
        {index !== 0 && (
          <span className="topheader-item__delimiter">{delimiter}</span>
        )}
        <a className="topheader-item__link" href={linkUrl || url}>
          {iconUrl && <img src={iconUrl} alt={text} />}
          {text}
        </a>
      </div>
    );
  };

  return <section className="topheader">{items.map(mapItem)}</section>;
};

export default TopHeader;
